// extracted by mini-css-extract-plugin
export default {"holder":"Home_holder__bxdvn","title":"Home_title__qAdt+","subtitle":"Home_subtitle__3pAVv"};